import { render, staticRenderFns } from "./EditDealTabInnerSection.vue?vue&type=template&id=19b81223&scoped=true&lang=pug&"
import script from "./EditDealTabInnerSection.vue?vue&type=script&lang=js&"
export * from "./EditDealTabInnerSection.vue?vue&type=script&lang=js&"
import style0 from "./EditDealTabInnerSection.vue?vue&type=style&index=0&id=19b81223&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b81223",
  null
  
)

export default component.exports